'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { usePathname } from '@/i18n/navigation'
import { menuVerticalItems } from '@/data/menuVertical'
import ChevronRotate from '@/components/common/ChevronRotate'
import { useHamburgerContext } from '@/components/common/Hamburger'
import { useUser } from '@auth0/nextjs-auth0'

const MenuVertical = () => {
  const [openMenuId, setOpenMenuId] = useState(-1)
  const pathname = usePathname()
  const { isOpen } = useHamburgerContext()
  const { user, isLoading } = useUser()

  useEffect(() => {}, [isOpen])

  const openMenu = (id: number) => {
    if (id === openMenuId) {
      setOpenMenuId(-1) // Close current menu (hide all submenu items)
    } else {
      setOpenMenuId(id) // Open menu (show all submenu items)
    }
  }

  // Some menus and/or menu items should be visible only if user is logged in

  // DONE: Collapse does not work correctly for RTL direction.
  // @@TODO: Scaling does not work correctly for expanded menu (did work before: https://dash.call2counter.com)

  // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/navigation_role
  // It is preferable to use the HTML5 <nav> element to define a navigation landmark.
  // If the HTML5 nav element technique is not being used, use a role="navigation" attribute to define a navigation landmark.
  return (
    // MenuVertical should appear below Main: z-20
    <nav aria-label="menu-side" className="z-20">
      <div className="w-40 py-1 border-x border-b border-theme-gray-200 dark:border-theme-gray-700 overflow-x-visible">
        {menuVerticalItems.map((menu) => (
          <nav
            aria-labelledby={String(menu.id)}
            // @@TODO: Fixed logic to hide menu(s) dependent on logged in user.
            className={`${menu.hidden || (!user && menu.name === 'SaaS') ? 'hidden' : ''}`}
            //className={`${menu.hidden ? 'hidden' : ''}`}
            key={menu.name}
          >
            <div className="transition-transform motion-reduce:transition-none">
              <button
                type="button"
                className="w-full px-1"
                onClick={() => openMenu(menu.id)}
              >
                <span className="relative flex justify-between hover:cursor-pointer px-2 py-1 rounded-md border-custom2">
                  {/* @@TODO: white-space-nowrap does not seem to work for Safari (tested 17.2.1 on 20240104). */}
                  <span
                    id={String(menu.id)}
                    className="flex font-normal text-base justify-left whitespace-nowrap text-ellipsis overflow-x-hidden"
                    key={menu.name}
                  >
                    {menu.name}
                  </span>
                  <span className="flex justify-right items-center mx-2">
                    <ChevronRotate open={menu.id === openMenuId} />
                  </span>
                </span>
              </button>
            </div>
            {/* submenus */}
            <div
              className={`${
                menu.id === openMenuId
                  ? // @@BUG: When using max-h-full or max-h-fit the transition does not work (pops immediately to end state).
                    // We can use a fixed maximum height value (e.g. max-h-50), provided it is tall enough to fit all menu items.
                    // If the height is too short, the lower menu items will be clipped.
                    'max-h-75 duration-300'
                  : 'max-h-0 duration-300'
              } overflow-hidden px-1`}
            >
              {menu.submenu.map((submenu) => (
                <div
                  className="flex relative font-light text-sm whitespace-nowrap text-ellipsis overflow-x-hidden"
                  key={submenu.name}
                >
                  {/* Designator for selected submenu */}
                  <div
                    className={`${
                      submenu.link === pathname
                        ? 'bg-theme-purple dark:bg-theme-yellow'
                        : ''
                    } h-fill w-2 mx-1 rounded-md`}
                  />
                  {/* Selected submenu */}
                  <div
                    className={`${
                      submenu.link === pathname
                        ? 'bg-violet-600 text-foreground-light dark:text-foreground-dark'
                        : 'border-custom2'
                    } rounded-md w-160 grow`}
                  >
                    <Link href={submenu.link}>
                      <div className="py-1 mx-2">{submenu.name}</div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </nav>
        ))}
      </div>
    </nav>
  )
}

export default MenuVertical
